import { MainTable } from "../../modules/main/MainTable"

export const MainPageWrapper = () => {
  return (
    <>
       {/* login on this and set current user */}
      <MainTable />
    </>
  )
}
